import {DateTime} from "luxon";

/**
 * Добавит ведущий ноль к дате или времени
 * @param value
 * @returns {*}
 */
function addLeadingZero(value){
    return value < 10 ? '0' + value : value;
}

function secondsToDaysHoursMin(seconds) {

    let days = Math.floor(seconds / 86400);
    let hours = Math.floor((seconds % 86400) / 3600);
    let minutes = Math.floor((seconds % 3600) / 60);

    if(days > 0){
        return days + "d " + hours + "h " + minutes + 'm';
    }else if (hours > 0) {
        return hours + "h " + minutes + 'm';
    } else {
        return minutes + "m";
    }
}

function secondsToHoursMin(seconds) {

    let hours = Math.floor(seconds / 3600);
    let minutes = Math.floor((seconds % 3600) / 60);

    if (hours > 0) {
        return hours + "h " + minutes + 'm';
    } else {
        return minutes + "m";
    }
}

function secondsToTime(seconds){
    let hours = Math.floor(seconds / 3600);
    let minutes = Math.floor((seconds % 3600) / 60);
    if (hours > 0) {
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    } else {
        return `00:${minutes.toString().padStart(2, '0')}`;
    }
}

function metersToDistance(meters){
    if (meters < 1000) {
        return Math.round(meters) + " м";
    } else if (meters < 100000) {
        return (Math.round(meters / 100) / 10) + " km";
    } else {
        return Math.round(meters / 1000) + " km";
    }
}


function minutesToTime(minutes) {
    let hours = Math.floor(minutes / 60);
    let remainingMinutes = minutes % 60;
    let hoursString = String(hours).padStart(2, '0');
    let minutesString = String(remainingMinutes).padStart(2, '0');
    return hoursString + ':' + minutesString;
}

function minutesToAMPMTime(minutes) {
    let hours = Math.floor(minutes / 60);
    let remainingMinutes = minutes % 60;
    let period = hours >= 12 ? 'PM' : 'AM';
    let displayHours = hours % 12 || 12;
    let hoursString = String(displayHours).padStart(2, '0');
    let minutesString = String(remainingMinutes).padStart(2, '0');
    return hoursString + ':' + minutesString + ' ' + period;
}

function isTimeLocale24(){
    return Number.isFinite(Number((new Date()).toLocaleString().slice(-1)));
}

function timeToLocale(date){

    let dateTime = DateTime.fromJSDate(date);

    if(isTimeLocale24()){
        return dateTime.toFormat("HH:mm");
    }else{
        return dateTime.toFormat("h:mma");
    }

}

function formDataToObject(formData) {
    const obj = {};
    formData.forEach((value, key) => {
        // Если ключ уже существует, преобразуем его в массив и добавляем новое значение
        if (obj[key]) {
            if (Array.isArray(obj[key])) {
                obj[key].push(value);
            } else {
                obj[key] = [obj[key], value];
            }
        } else {
            obj[key] = value;
        }
    });
    return obj;
}

/**
 * Сравнивает два объекта вместе с их свойствами. Идентичны или нет
 * @param obj1
 * @param obj2
 * @returns {boolean}
 */
function objectsEqual(obj1, obj2) {
    if (obj1 === obj2) return true;

    if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 === null || obj2 === null) {
        return false;
    }

    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
        return false;
    }

    for (let key of keys1) {
        if (!keys2.includes(key) || !objectsEqual(obj1[key], obj2[key])) {
            return false;
        }
    }

    return true;
}

export {formDataToObject, secondsToDaysHoursMin, secondsToHoursMin, secondsToTime, metersToDistance, minutesToTime, minutesToAMPMTime, isTimeLocale24, timeToLocale, objectsEqual, addLeadingZero}